export default __webpack_public_path__ + "static/media/newSubscription.9d637b78.png";